import * as React from "react";
const EmailIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 39 38"
        fill="none"
        {...props}
    >
        <path
            fill="#fff"
            d="M19.595 37.343c10.277 0 18.607-8.33 18.607-18.607C38.202 8.46 29.872.129 19.595.129 9.32.129.988 8.459.988 18.736c0 10.276 8.33 18.607 18.607 18.607Z"
        />
        <path
            fill="#009448"
            d="m19.477 18.257 10.37-6.466a2.17 2.17 0 0 0-.345-.03H9.451c-.116.002-.232.011-.346.03l10.372 6.466Z"
        />
        <path
            fill="#009448"
            d="M20.13 20.757a.409.409 0 0 1-.044.023l-.045.024c-.08.043-.164.076-.251.1l-.026.006c-.094.023-.19.035-.285.036-.097 0-.192-.013-.286-.036l-.026-.006a1.224 1.224 0 0 1-.25-.1l-.046-.024c-.014-.008-.03-.014-.044-.023L7.303 13.572a2.178 2.178 0 0 0-.033.373v11.531a2.184 2.184 0 0 0 2.184 2.184H29.5a2.184 2.184 0 0 0 2.184-2.184V13.945c-.001-.125-.013-.25-.035-.373l-11.52 7.185Z"
        />
    </svg>
);
export default EmailIcon;
